// import iHeaderI18n from '@/layouts/basic-layout/header-i18n';
import { mapState } from 'vuex';

export default {
    // components: { iHeaderI18n },
    computed: {
        ...mapState('admin/layout', [
            'showI18n'
        ])
    }
}



// WEBPACK FOOTER //
// ./src/pages/account/mixins.js